let inject = [
    '$scope',
    'ReportPendientesItemsService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    'NgTableParams',
    '$uibModal',
    '$filter'
];

class ReportPendientesItemsController {
    constructor($scope,
                ReportPendientesItemsService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                NgTableParams,
                $uibModal,
                $filter) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        this.$filter = $filter;
        // this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.NgTableParams = NgTableParams;
        this.ReportPendientesService = ReportPendientesItemsService;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;

        this.PendientesItems = null;
        this.state = {};
        this.branches = [];

        this.statePendiente = {};
        this.pendienteSelected = null;
        this.pendienteSelectedBase = null;
        this.pendienteVrNetoTotal = 0;
        this.pendienteVrNetoPendiente = 0;
        this.watchingPendiente = false;

        // ngTable Params
        this.ngTableConfigPendiente = null;
        this.ngTableColsPendiente = null;

        this.totalCantPendientes = 0;
        this.totalValuePendingPendientes = 0;
        this.updatedAt = '';

        // ngTable Params
        this.ngTableConfig = null;
        this.ngTableCols = null;
        this.thirdSelected = null;
        this.branchesSelected = null;

        this.exportingData = false;
        this.exportCorrect = false;
        this.exportingDataPdf = false;
        this.exportCorrectPdf = false;


        this.sort = null;
        this.searchText = '';
        this.sortType = 'pedido_id';
        this.sortOrientation = 'DESC';
        this.sortReverse = true;
        this.userPendientes = [];
        this.summary = [];
        this.itemsPerPage = 12;
        this.loadingUserPendientes = true;
        this.loadedUserPendientes = false;
        this.errorloadingUserPendientes = false;
        this.currentPage = 1;
        this.actualPage = 0;
        this.filters = {};
        this.filtersCopy = {};


        this.maxSize = 5;
        this.bigTotalItems = 0;
        this.bigCurrentPage = 1;
        this.totalItemsPage = 12;
        this.statictics = {};

        this.bigTotalItemsDetails = 0;
        this.bigCurrentPageDetail = 1;
        this.totalItemsPageDetail = 12;


        this.count = 0;
        this.numberDaysReport =null;
    }

    $onInit() {
        if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
        if (!this.shCtrl.globals.currentClient.third) return;
        if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
        let paginar = __env.adaptative === true;
        this.getPendienteStates(false, paginar);
    }

    getBranches(item) {
        this.ReportPendientesService.getBranchesByThirdId(item.id).then(response => {
            this.branches = response;
        }); 
    }

    getPendienteStates(manual, paginar = true, pendienteRequest = false, pendienteObject = null, paginationInicial, paginationFinal) {

        this.sort = manual;

        let documentNumber = '';
        let branchCode = '';

        let limit = this.totalItemsPage;
        let page = this.bigCurrentPage;

        if (!paginar) {
            limit = "";
            page = "";
        }else{
            if (paginationInicial==undefined && paginationFinal==undefined) {
                paginationInicial   =   0;
                paginationFinal     =   limit;
            }
        }


        try {
            if (manual) {
                console.log("enetering in manual", manual);
                this.pendientes = [];
                documentNumber = this.thirdSelected.nit;
                if (angular.isArray(this.branchesSelected)) {
                    branchCode = this.branchesSelected;
                } else if (this.branchesSelected) {
                    branchCode = [this.branchesSelected.id];
                } else {
                    branchCode = [];
                }

            } else {
                documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
                branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
            }
        }
        catch (e) {
            return;
        }

        if (!documentNumber || !branchCode) {
            alert('Para realizar la consulta se necesita el numero del tercero y el codigo de la sucursal.');
        }
        else {
            this.state = {};
            this.state.loading = true;
            if (manual) {
                this.ReportPendientesService.getPendientesStatesBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin, limit, page).then(pendientes => {
                    this.state.loading = false;
                    this.state.loaded = true;

                    this.pendientes = pendientes.data;
                    this.numberDaysReport = pendientes.numberDays;

                    this.totalCantPendientes = 0;
                    this.totalValuePendingPendientes = 0;

                    angular.forEach(pendientes.data, (pendiente) => {
                        let cant_pendiente = +pendiente.cant_pendiente;
                        let valor_pendiente = +pendiente.valor_pendiente;

                        this.totalCantPendientes = this.totalCantPendientes + cant_pendiente;
                        this.totalValuePendingPendientes = this.totalValuePendingPendientes + valor_pendiente;
                    });

                    this.bigTotalItems = this.pendientes.total;

                    this.initNgTable();

                    this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                }).catch(error => {
                    this.state.loading = false;
                    this.state.error = true;
                });
            } else {
                this.ReportPendientesService.getPendienteStates(documentNumber, branchCode, limit, page, pendienteRequest && pendienteObject.pendienteColumn.length > 0 ? pendienteObject : null)
                    .then(pendientes => {
                        this.state.loading = false;
                        this.state.loaded = true;
                        this.numberDaysReport = pendientes.numberDays;
                        // console.log("page: "+paginationInicial);
                        // console.log("limit: "+paginationFinal);
                        this.pendientes = pendientes.data.slice(paginationInicial,paginationFinal); 

                        if(!paginar){
                            this.totalCantPendientes = 0;
                            this.totalValuePendingPendientes = 0;

                            angular.forEach(pendientes.data, pendiente => {
                                let cant_pendiente = +pendiente.cant_pendiente;
                                let valor_pendiente = +pendiente.valor_pendiente;

                                this.totalCantPendientes = this.totalCantPendientes + cant_pendiente;
                                this.totalValuePendingPendientes = this.totalValuePendingPendientes + valor_pendiente;
                            });
                        }else{
                            //this.totalCantPedidas = pendientes.totalCantPedida;
                            this.totalCantPendientes = pendientes.totalCantPendiente;
                            this.totalValuePendingPendientes = pendientes.totalCantPedida;
                        }

                        this.bigTotalItems = pendientes.total;

                        this.initNgTable();

                        this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    })
                    .catch((error) => {
                        this.state.loading = false;
                        this.state.error = true;
                    });
            }
        }
    }

    selectPendiente(pendienteSelected, paginar = false) {
        this.watchingPendiente = true;
        this.statePendiente.loading = true;
        this.pendienteSelectedBase = pendienteSelected;        
        this.exportCorrect = false;
        this.exportCorrectPdf = false;
        let documentNumber = '';
        let branchCode = '';
        let nit = '';

        let limit = this.totalItemsPageDetail;
        let page = this.bigCurrentPageDetail;

        if (!paginar) {
            limit = "";
            page = "";
        }

        try {
            nit = this.thirdSelected.nit;
        } catch (e) {
        }
        if (nit) {
            documentNumber = this.thirdSelected.nit;
            if (angular.isArray(this.branchesSelected)) {
                branchCode = this.branchesSelected;
            } else if (this.branchesSelected) {
                branchCode = [this.branchesSelected.id];
            } else {
                branchCode = [];
            }

        } else {
            documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
            branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
        }

        this.ReportPendientesService.getPendienteState(documentNumber, limit, page)
            .then((pendiente) => {
                this.statePendiente.loading = false;
                this.statePendiente.loaded = true;
                this.pendienteSelected = pendiente.data;
                if (!paginar) {
                    this.bigTotalItemsDetails = pendiente.total;
                    this.pendienteVrNetoTotal = pendienteSelected.valor_pagar;
                    this.pendienteVrNetoPendiente = pendienteSelected.valor_pendiente;
                }

                this.initNgTablePendiente();
            }).catch((error) => {
            this.statePendiente.loading = false;
            this.statePendiente.loaded = true;
            this.statePendiente.error = true;
        });
    }

    blurPendiente() {
        this.pendienteSelected = null;
        this.watchingPendiente = false;        
        this.exportCorrect = false;
        this.exportCorrectPdf = false;
    }

    initNgTablePendiente() {
        /**
         * destino:                             "ORDEN DE COMPRA 30455 **23183** LO RECOGEN"
         * fecha_pedido:                  (OK)  "2016-07-18 00:00:00"
         * id:                                  248
         * item_cantidad_despachada:      (OK)  0
         * item_cantidad_pedida:          (OK)  4
         * item_centro_operacion_pedido:        1
         * item_descripcion:              (OK)  "TRIAGE CARDIAC PANEL X 25 PBS"
         * item_estado:                   (OK)  null
         * item_fecha_entrega:            (OK)  "2016-07-18 00:00:00"(OK)
         * item_referencia:               (OK)  "97000HSEU"
         * item_unidad_medida:            (OK)  "UND"
         * item_valor_descuento:          (OK)  0
         * item_valor_total:              (OK)  1800000
         * item_valor_unitario:           (OK)  450000
         * pedido_estado:                       "1"
         * pedido_id:                           "PV-150296"
         * sucursal:                            "ANGEL DIAGNOSTICA S A/CAMBULOS"
         * sucursal_id:                         "01"
         * tercero:                             "ANGEL DIAGNOSTICA S A"
         * tercero_id:                          "805013591"
         * valor_pagar:                         null
         * valor_pendiente:                     null
         * vendedor:                            "ALVAREZ ACHURY CONSTANZA VIVIANA"
         * vendedor_id:                         "0231"
         */

        this.ngTableColsPendiente = [
            {
                field: "fecha_pedido",
                title: "Fecha Pedido",
                sortable: "fecha_pedido",
                filter: {"fecha_pedido": "text"},
                show: true
            },
            {
                field: "item_fecha_entrega",
                title: "Entrega",
                sortable: "item_fecha_entrega",
                filter: {"item_fecha_entrega": "text"},
                show: true
            },
            {
                field: "item_referencia",
                title: "Ref.",
                sortable: "item_referencia",
                filter: {"item_referencia": "text"},
                show: true
            },
            {
                field: "item_descripcion",
                title: "Descripción",
                sortable: "item_descripcion",
                filter: {"item_descripcion": "text"},
                show: true
            },
            {
                field: "item_estado",
                title: "Estado ítem",
                sortable: "item_estado",
                filter: {"item_estado": "text"},
                show: true
            },
            {
                field: "item_unidad_medida",
                title: "U.M.",
                sortable: "item_unidad_medida",
                filter: {"item_unidad_medida": "text"},
                show: true
            },
            {
                field: "item_cantidad_pedida",
                title: "Cant. Pedida",
                sortable: "item_cantidad_pedida",
                filter: {"item_cantidad_pedida": "text"},
                show: true
            },
            // {
            //   field: "item_cantidad_despachada",
            //   title: "Cant. Despachada",
            //   sortable: "item_cantidad_despachada",
            //   filter: { "item_cantidad_despachada": "text" },
            //   show: true
            // },
            // {
            //   field: "item_cantidad_pendiente",
            //   title: "Cant. Pendiente",
            //   sortable: "item_cantidad_pendiente",
            //   filter: { "item_cantidad_pendiente": "text" },
            //   show: true
            // },
            {
                field: "item_valor_unitario",
                title: "Vr. Unit.",
                sortable: "item_valor_unitario",
                filter: {"item_valor_unitario": "text"},
                show: true
            },
            {
                field: "item_valor_impuesto",
                title: "VR IMPUESTOS",
                sortable: "item_valor_impuesto",
                filter: {"item_valor_impuesto": "text"},
                show: true
            },
            {
                field: "item_valor_descuento",
                title: "Vr. Desc.",
                sortable: "item_valor_descuento",
                filter: {"item_valor_descuento": "text"},
                show: true
            },
            {
                field: "item_valor_total",
                title: "Vr. Neto",
                sortable: "item_valor_total",
                filter: {"item_valor_total": "text"},
                show: true
            }
        ];

        let initialParams = {
            count: 20,
            sorting: {fecha_pedido: "desc"}
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.pendientes
        };

        this.ngTableConfigPendiente = new this.NgTableParams(initialParams, initialSettings);
    }

    initNgTable() {

        this.ngTableCols = [
            {
                field: "pedido_id",
                title: "Pedido",
                sortable: "pedido_id",
                filter: {"pedido_id": "text"},
                show: true
            },
            {
                field: "fecha_pedido",
                title: "Fecha del Pedido",
                sortable: "fecha_pedido",
                filter: {"fecha_pedido": "text"},
                show: true
            },
            {
                field: "co_nombre",
                title: "Centro operacion",
                sortable: "co_nombre",
                filter: {"co_nombre": "text"},
                show: true
            },
            {
                field: "destino",
                title: "Direccion",
                sortable: "destino",
                filter: {"destino": "text"},
                show: true
            },
            {
                field: "item_referencia",
                title: "Ref.",
                sortable: "item_referencia",
                filter: {"item_referencia": "text"},
                show: true
            },
            {
                field: "item_descripcion",
                title: "Ítem",
                sortable: "item_descripcion",
                filter: {"item_descripcion": "text"},
                show: true
            },
            {
                field: "item_pedido_estado",
                title: "Estado",
                sortable: "item_pedido_estado",
                filter: {"item_pedido_estado": "text"},
                show: true
            },
            {
                field: "cant_pedida",
                title: "Cant. Pedida",
                sortable: "cant_pedida",
                filter: {"cant_pedida": "number"},
                show: true
            },
            {
                field: "cant_pendiente",
                title: "Cant. Pendiente",
                sortable: "cant_pendiente",
                filter: {"cant_pendiente": "number"},
                show: true
            },
            {
                field: "valor_pendiente",
                title: "Vr. Neto Pendiente",
                sortable: "valor_pendiente",
                filter: {"valor_pendiente": "number"},
                show: true
            },
        ];

        let initialParams = {
            count: 20,
            sorting: {fecha_pedido: "desc"}
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.pendientes
        };

        this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
    }

    exportExcel() {
        this.exportingData = true;        
        this.exportCorrect = false;
        this.exportCorrectPdf = false;
        //console.log(this.orders);
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        this.ReportPendientesService.getExportExcel(this.pendientes, nameClient)
            .then((datos) => {
                console.log(datos.data.url_excel);
                open(datos.data.url_excel, '_blank');
                this.exportingData = false;
                this.exportCorrect = true;

            }).catch((error) => {
            this.exportingData = false;
            this.exportCorrect = false;
        });
    }

    exportPDF() {
        this.exportCorrect = false;
        this.exportCorrectPdf = false;
        this.exportingData = true;
        //console.log(this.payments);
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        let date = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss')
        
        this.ReportPendientesService.getExportPdf(this.pendientes, nameClient)
            .then((responsepdf) => {
                
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(responsepdf);
                link.download = `${nameClient}-ItemsPendientes-${date}.pdf`;
                link.target = '_blank';
                link.click();
                
                this.exportingData = false;
                this.exportCorrectPdf = true;

            }).catch((error) => {
                console.log(error);
                this.exportingData = false;
                this.exportCorrectPdf = false;

        });
    }

    showSort(value) {
        this.sort = value;
    }

}

ReportPendientesItemsController.$inject = inject;

export default ReportPendientesItemsController;




/** WEBPACK FOOTER **
 ** ./www/components/reports/pendientesItems/pendientes-items.controller.js
 **/